import React from 'react';
import PropTypes from 'prop-types';
import { observer } from 'mobx-react';
import { action, observable } from 'mobx';
import FormContent from '../../../commons/Form/FormContent/FormContent';
import FormHeader from '../../../commons/Form/FormHeader/FormHeader';
import NotAllowedClustersStore from '../../../../state/NotAllowedClustersStore';
import Button from '../../../commons/Button/Button';
import PersonalInfoService from '../../../../services/PersonalInfoService';

const ALERT_TIMEOUT = 20000;

@observer
class DownloadPersonalInfo extends React.Component {
  @observable status;

  constructor(props) {
    super(props);
    this.initializeStatus();
  }

  initializeStatus() {
    this.status = {
      isLoading: false,
      errorMessage: undefined,
    };
  }

  @action.bound
  handleClickDownload() {
    this.status.isLoading = true;
    PersonalInfoService.downloadPersonalInfo()
      .then((data) => {
        const url = window.URL.createObjectURL(new Blob([data]));
        const link = document.createElement('a');
        link.href = url;
        link.download = 'personal-info.pdf';
        document.body.append(link);
        link.click();
        link.remove();
        window.URL.revokeObjectURL(url);
      })
      .catch((error) => {
        this.status.errorMessage = error.message;
        setTimeout(() => {
          this.status.errorMessage = undefined;
        }, ALERT_TIMEOUT);
      })
      .finally(() => {
        this.status.isLoading = false;
      });
  }

  render() {
    const disable = this.props.hasError || NotAllowedClustersStore.personalInfo;
    return (
      <FormContent className="-eva-3-bc-white -pl-md-4 -pr-md-4 -pt-3 -pb-2 -pl-2 -pr-2">
        <div>
          <FormHeader
            errorMessage={this.status.errorMessage}
            title="Baixe seus dados"
            description="Todos os seus dados pessoais em um documento PDF."
            className="-mb-2 -mb-md-1"
            isMerging={this.props.isMerging && this.props.isWebview}
            hasError={this.props.hasError}
            disableCluster={this.props.hasError}
          />
          <Button
            loading={this.status.isLoading}
            disable={disable || this.props.isMerging}
            onClick={this.handleClickDownload}
            text="Baixar documento"
          />
        </div>
      </FormContent>
    );
  }
}

DownloadPersonalInfo.defaultProps = {
  isWebview: false,
};

DownloadPersonalInfo.propTypes = {
  isMerging: PropTypes.bool.isRequired,
  hasError: PropTypes.bool.isRequired,
  isWebview: PropTypes.bool,
};

export default DownloadPersonalInfo;
